import React, { useLayoutEffect } from "react";
import emailImg from "../assets/images/email.png";
import phoneImg from "../assets/images/phone.png";

const Contact = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section>
        <div className="contact container">
          <div className="header main">
            <p className="first">LET'S HEAR FROM YOU</p>
            <h1>Contact Sales</h1>
            <p className="second">
              Feel free to reach out to our customer success team. We’re always
              available and happy to assist you.
            </p>
          </div>
        </div>
      </section>
      <section>
        <div className="form-wrapper container">
          <div className="email-wrapper">
            <img src={emailImg} alt="emailimg" />
            <h2>Email</h2>
            <h5>We'll reply as soon as possible.</h5>
            <p>Send us a mail</p>
          </div>
          <div className="phone-wrapper">
            <img src={phoneImg} alt="phone-img" />
            <h2>Phone</h2>
            <h5>Talk to us (Mon - Fri, 9:00 - 18:00)</h5>
            <p>Call +234 814 551 5280</p>
          </div>
        </div>
      </section>
      <section>
        <div className="form container">
          <h2>Have a quick question?</h2>
          <p>Tell us how we can help and we’ll get in touch shortly.</p>
          <form className="form-container">
            <input placeholder="Full Name" type="text" />
            <input placeholder="Company Name" type="text" />
            <input placeholder="Email" type="email" />
            <input placeholder="Phone" type="number" />
            <textarea row="3" placeholder="How can we help you?"></textarea>
            <button>Submit</button>
          </form>
        </div>
      </section>
    </>
  );
};

export default Contact;
